//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Vue from "vue";
import { useBloomreach, useUiState } from "~/composables";
import {onSSR, useVSFContext} from "@vue-storefront/core";
import HeaderNavigation from "~/components/HeaderNavigation.vue";
import CategoryBreadcrumbs from "~/components/Category/CategoryBreadcrumbs.vue";
import { useRoute, computed } from "@nuxtjs/composition-api";
import { getBreadcrumbs } from "~/common";
import { checkCMSFlag, getCMSLabels } from "~/helpers/globalLabels";

export default Vue.extend({
  name: "Menu",
  components: {
    HeaderNavigation,
    CategoryBreadcrumbs,
  },
  props: {
    component: {},
    page: {},
  },
  computed: {
    isHomePage() {
      return this.$route?.params?.pathMatch == ''
    },
    currentPageHasP() {
      if(!this.$route) return false;

      return this.$route.fullPath.includes('/p/');
    }
  },
  setup() {
    const { isMobileMenuOpen, toggleMobileMenu } = useUiState();
    const { initMegaMenu, megaMenuContent } = useBloomreach("brx");
    const { localePath } = useVSFContext();
    const router = useRoute();
    const currentRoute = computed(() =>
      router?.value?.params?.pathMatch?.split("/")
    );

    const categoryBreadcrumbs = computed(() => {
      return getBreadcrumbs(currentRoute.value, localePath);
    });

    const isSimplifiedHeaderEnable = checkCMSFlag('simplified-header-flag', 'true');

    onSSR(async () => {
      await initMegaMenu();
    });

    return {
      isMobileMenuOpen,
      toggleMobileMenu,
      megaMenuContent,
      categoryBreadcrumbs,
      isSimplifiedHeaderEnable
    };
  },
});
